/* lyvoi-cart-attribution.js — 把广告点击 ID 写进购物车 attributes，随订单进后台（飞书 NO.1534，2026-09-17 加）。
   为什么：iOS 掉归因后，订单本身不带「从哪条广告来」。竞品 RIIGID / Wagging Rights 都这么做，我方 cart.attributes 实测为 {}。
   写哪些：_fbp（Meta 浏览器 ID）· _fbc（Meta 点击 ID，cookie 没有但 URL 带 fbclid 时按 Meta 格式自拼）· _ttclid · _ttp（TikTok）。
   下划线开头 = Shopify 私有属性：结账页和客户邮件不显示，订单后台「Additional details」和 API note_attributes 里有。
   已知盲区：PDP 上的 Buy it now / 钱包快捷付不走购物车，那部分订单带不上这些属性。
   只读 cookie + 一次 /cart.js，值有变化才 POST /cart/update.js；任何失败都静默，绝不影响加购和结账。 */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function cookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf('=');
      if (parts[i].slice(0, eq) === name) {
        try { return decodeURIComponent(parts[i].slice(eq + 1)); } catch (e) { return parts[i].slice(eq + 1); }
      }
    }
    return '';
  }

  function param(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; } catch (e) { return ''; }
  }

  function marketingDenied() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false);
    } catch (e) { return false; }
  }

  function collect() {
    var fbclid = param('fbclid');
    var fbc = cookie('_fbc');
    // URL 带新 fbclid 时 Meta pixel 往往晚于本脚本才更新 _fbc cookie，此时 cookie 还是上一次点击，以 URL 为准
    if (fbclid && fbc.split('.').slice(3).join('.') !== fbclid) fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    var want = {
      _fbp: cookie('_fbp'),
      _fbc: fbc,
      _ttclid: param('ttclid') || cookie('ttclid'),
      _ttp: cookie('_ttp')
    };
    for (var k in want) if (!want[k]) delete want[k];
    return want;
  }

  // _fbc 的时间戳段每次自拼都不同，只比 fbclid 段，免得每页都重写
  function same(key, have, want) {
    if (key === '_fbc' && have && want) {
      return have.split('.').slice(3).join('.') === want.split('.').slice(3).join('.');
    }
    return have === want;
  }

  function sync() {
    if (marketingDenied() || !window.fetch) return Promise.resolve();
    var want = collect();
    if (!Object.keys(want).length) return Promise.resolve();
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // 空车不写：首访时还没有购物车，这时 POST update.js 会新建一辆空车，和同时进行的加购抢购物车 cookie，
        // 加购的那辆车会丢（2026-10-06 实测：首屏约 3 秒点加购，5 次丢 2 次；屏蔽本脚本 5/5 正常）
        if (!cart || !cart.item_count) return 'empty';
        var have = cart.attributes || {};
        var diff = {}, n = 0;
        for (var k in want) {
          if (!same(k, have[k], want[k])) { diff[k] = want[k]; n++; }
        }
        if (!n) return;
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: diff })
        });
      })
      .catch(function () {});
  }

  function start() {
    // 车是空的就每 5 秒再看一次（最多 2 分钟），等加购把车建好再写，不自己建车。
    // 顺带覆盖「Meta pixel 晚于本脚本才种 _fbp」：每次重试都会重新读 cookie。
    var tries = 0;
    (function loop() {
      sync().then(function (r) {
        if ((r === 'empty' || !cookie('_fbp')) && ++tries < 24) setTimeout(loop, 5000);
      });
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
